import logEvent from '../../../utils/TagManager';
import { IMAGE_ADDED } from '../../../sagas/ReturnedChangesetProcessor';

export const IMAGES_TO_UPLOAD = 'IMAGES_TO_UPLOAD';
const UPLOAD_PERCENT_UPDATE = 'UPLOAD_PERCENT_UPDATE';
const START_IMAGE_UPLOAD = 'START_IMAGE_UPLOAD';
const FINISHED_UPLOADING = 'UPLOAD_FINISHED';
export const FAILED_PRE_RESIZE = 'FAILED_PRE_RESIZE';
export const FAILED_UPLOADS = 'FAILED_UPLOADS';

const initialState = [];

export function uploadImages(images, _ = null, galleryName = null) {
  logEvent('Add Photos', 'Started photos upload', images.length, 0);
  return {
    type: IMAGES_TO_UPLOAD,
    images,
    galleryName,
  };
}

export function StartImageUpload(image) {
  return {
    type: START_IMAGE_UPLOAD,
    image,
  };
}

export function UpdateImageUploadPercent(image, percent) {
  return {
    type: UPLOAD_PERCENT_UPDATE,
    image,
    percent,
  };
}

export function FinishedUploading(image, success) {
  return {
    type: FINISHED_UPLOADING,
    image,
    success,
  };
}

function findIndex(state, imageID) {
  let foundIndex = -1;
  state.find((image, index) => {
    if (image && image.id && image.id.toLowerCase() === imageID.toLowerCase()) {
      foundIndex = index;
    }
  });

  return foundIndex;
}

function finished(state, action) {
  let foundIndex = findIndex(state, action.image.imageID);
  if (foundIndex >= 0) {
    return [...state.slice(0, foundIndex), ...state.slice(foundIndex + 1)];
  }
  return state;
}

function updatePercentage(state, action) {
  let foundIndex = findIndex(state, action.image.id);
  let u = Object.assign({}, action.image, {
    uploadPercent: action.percent,
    uploading: true,
  });

  if (foundIndex >= 0) {
    return [...state.slice(0, foundIndex), u, ...state.slice(foundIndex + 1)];
  }
  return state;
}

function startImageUpload(state, action) {
  let foundIndex = findIndex(state, action.image.id);
  let u = Object.assign({}, action.image, {
    uploading: true,
    uploadPercent: 0,
  });

  if (foundIndex >= 0) {
    return [...state.slice(0, foundIndex), u, ...state.slice(foundIndex + 1)];
  }
  return state;
}

const imagesToUpload = (state = initialState, action) => {
  switch (action.type) {
    case IMAGES_TO_UPLOAD:
      return state.concat(
        action.images.map((image) => {
          image.uploadPercent = 0;
          return image;
        }),
      );

    case START_IMAGE_UPLOAD:
      return startImageUpload(state, action);

    case UPLOAD_PERCENT_UPDATE:
      return updatePercentage(state, action);
    case FINISHED_UPLOADING:
    case IMAGE_ADDED:
      return finished(state, action);
    case FAILED_PRE_RESIZE:
      return finished(state, action);
    default:
      return state;
  }
};

export default imagesToUpload;
